export default __webpack_public_path__ + "static/20241218-dac66ea4a94a4d3f5e9fc79a524ced1d.png";